export default (t = 100, f) => new Promise((resolve) => {
    (function tryIt() {
        const r = f();
        if (r) {
            resolve(r);
        }
        else {
            setTimeout(tryIt, t);
        }
    })();
});
//# sourceMappingURL=poll.mjs.map